<div class="main">

    <!-- Closed, the field IS the selection; open, it is a search box. One box either way, so the
         control never changes size and nothing beside it moves when it is used. -->
    <div class="select" [ngClass]="{'open': isOpen, 'disabled': disable}" (click)="open()">

        <ng-container *ngIf="!isOpen">

            <div class="valid-selection" *ngIf="selectedOption">
                <div class="search-image" *ngIf="!!selectedOption.imageUrl || !!selectedOption.iconUrl || !!defaultImageUrl">
                    <img *ngIf="!selectedOption.imageUrl && !selectedOption.iconUrl" [src]="defaultImageUrl" class="icon-white">
                    <img *ngIf="!!selectedOption.iconUrl" [src]="selectedOption.iconUrl" class="icon-white">
                    <img *ngIf="!!selectedOption.imageUrl" [src]="selectedOption.imageUrl">
                </div>
                <!-- the name only: the description is what tells two candidates apart while choosing,
                     and once one is chosen it is just a long string in a short field -->
                <div class="selection">
                    <div class="name">{{ selectedOption.name }}</div>
                </div>
                <div class="clear-button" *ngIf="!disableUnselect && !disable"
                    (click)="$event.stopPropagation(); clearSelection()">
                    <img src="/assets/icons/close.svg" class="icon-white">
                </div>
            </div>

            <div class="no-selection" *ngIf="!selectedOption">{{ prompt }}</div>
        </ng-container>

        <input *ngIf="isOpen" #searchInput type="text" [formControl]="searchControl" [placeholder]="prompt"
            (blur)="close()" (click)="$event.stopPropagation()">
    </div>

    <div class="option-wrapper fade-in" *ngIf="isOpen" [ngClass]="{'above': openAbove}">
        <div class="options" *ngVar="(highlightedOptionIndex$ | async) as highlightedOptionIndex">

            <!-- mousedown is swallowed so the field's blur does not close the list before the click
                 on an option has landed -->
            <div class="option" *ngFor="let option of (filteredOptions$ | async); let i = index; trackBy: trackByOptionId"
                [id]="'entity_select_option_' + i" [ngClass]="{'highlighted': i === highlightedOptionIndex}"
                (mousedown)="$event.preventDefault()" (click)="selectOption(option)">

                <!-- the list is not capped, so it can run to every component in the open orders:
                     lazy images keep that to the rows actually scrolled into view -->
                <div class="search-image" *ngIf="!!option.imageUrl || !!option.iconUrl || !!defaultImageUrl">
                    <img *ngIf="!option.imageUrl && !option.iconUrl" [src]="defaultImageUrl" class="icon-white">
                    <img *ngIf="!!option.iconUrl" [src]="option.iconUrl" class="icon-white" loading="lazy">
                    <img *ngIf="!!option.imageUrl" [src]="option.imageUrl" loading="lazy">
                </div>
                <div class="info">
                    <div class="name" [innerHtml]="option.name | textHighlight: searchControl.value || ''"></div>
                    <div class="description" *ngIf="!!option.description"
                        [innerHtml]="option.description | textHighlight: searchControl.value || ''"></div>
                </div>
            </div>

            <div class="no-options" *ngIf="!(filteredOptions$ | async)?.length">{{ noResultsText }}</div>
        </div>
    </div>
</div>
